// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bfe_a bia_tr","StrollerBoxWidget__imageCounselling":"bfe_b bia_kg"};